import { __assign } from "tslib";
import React from 'react';
export var ImageCell = function (props) {
    var field = props.field, cell = props.cell, tableStyles = props.tableStyles, cellProps = props.cellProps;
    var displayValue = field.display(cell.value);
    return (React.createElement("div", __assign({}, cellProps, { className: tableStyles.cellContainer }),
        React.createElement("img", { src: displayValue.text, className: tableStyles.imageCell })));
};
//# sourceMappingURL=ImageCell.js.map